import classNames from "classnames";
import { BandBadge } from "../../primitives";
import { BlockBaseProps } from "../../types";
import styles from "../table.module.scss";
import InstallmentsTableSkeleton from "./Skeleton";

export interface InstallmentRow {
  id: number;
  /** "2 / 6" */
  number: string;
  /** Already formatted, without the currency prefix. */
  amount: string;
  /** Paid, Pending, Overdue, In review or Rejected. */
  status: string;
  due: string;
  paidOn: string;
}

interface InstallmentsTableProps extends BlockBaseProps {
  installments: InstallmentRow[];
  title?: string;
  /** Short summary on the heading's right, e.g. "Plan name · 3 of 6 paid". */
  meta?: string;
  currency?: string;
}

const COLUMNS = ["Installment", "Amount", "Status", "Due date", "Paid on"];

/** The instalment schedule of the school's plan, as the school panel shows it. */
function InstallmentsTable({
  installments,
  title = "Installments",
  meta,
  currency = "Rs.",
  loading,
  className,
}: InstallmentsTableProps) {
  if (loading) {
    return (
      <InstallmentsTableSkeleton
        count={installments.length || 3}
        className={className}
      />
    );
  }

  return (
    <div className={classNames(styles.card, className)}>
      <div className={classNames(styles.heading, styles.headingRow)}>
        <span>{title}</span>
        {meta && <span className={styles.headingMeta}>{meta}</span>}
      </div>
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              {COLUMNS.map((column) => (
                <th key={column} className={styles.th}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!installments.length && (
              <tr>
                <td className={`${styles.td} ${styles.empty}`} colSpan={COLUMNS.length}>
                  No installments found for this plan.
                </td>
              </tr>
            )}
            {installments.map((installment) => (
              <tr key={installment.id}>
                <td className={`${styles.td} ${styles.strong}`}>
                  {installment.number}
                </td>
                <td className={`${styles.td} ${styles.nowrap}`}>
                  {`${currency} ${installment.amount}`}
                </td>
                <td className={styles.td}>
                  <BandBadge band={installment.status} status />
                </td>
                <td
                  className={classNames(
                    styles.td,
                    styles.nowrap,
                    installment.status === "Overdue" && styles.dueUrgent
                  )}
                >
                  {installment.due}
                </td>
                <td className={`${styles.td} ${styles.nowrap}`}>
                  {installment.paidOn}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default InstallmentsTable;
